import i18n from '@/plugins/i18n'

import { useLookup } from '@/composables/data-grid'
import { codeNameDisplayExpr } from '@/composables/label'
import { useQuantityColumn, useNotesColumn, useSupplierBrandColumn, useTotalNoVatColumn, useTotalVatColumn, useVatTypeColumn, useProductColumns, useDocumentRowTypeColumn } from '@/composables/data-grid-column'

import { useRegistryStore } from '@/stores/registry.store'
import { useWebSiteStore } from '@/stores/web-site.store'

export const useImportRow = () => {
  const { t } = i18n.global
  const registryStore = useRegistryStore()
  const webSiteStore = useWebSiteStore()
  const canEditQuantity = (row) => {
    const isTextRow = row?.document_row_type === webSiteStore.documentRowTypesEnum.TEXT
    const isAutodataLaborRow = (
      row?.source === webSiteStore.importRowTypesEnum.AUTODATA &&
      row?.document_row_type === webSiteStore.documentRowTypesEnum.LABOR
    )
    return !isTextRow && !isAutodataLaborRow
  }

  const useColumns = ({ displayedSources }) => {
    const supplierBrandDisplayValue = (rowData) => {
      const code = rowData?.supplier_brand_ref_code || rowData?.supplier_brand_code
      const supplierBrand = registryStore.supplierBrands.find(item => item.code === code)
      return supplierBrand ? codeNameDisplayExpr(supplierBrand) : code
    }

    return [
      {
        caption: t('common.source'),
        dataField: 'source',
        lookup: useLookup({
          store: webSiteStore.getLocalizedImportRowTypes().filter(
            item => !displayedSources?.length || displayedSources.includes(item.id)
          ),
        }),
        cellTemplate: 'importRowTypeCellTemplate',
        width: '6rem',
      },
      {
        caption: t('common.type'),
        dataField: 'source_type',
        lookup: useLookup({
          store: webSiteStore.getLocalizedImportRowSourceTypes(),
        }),
        width: '6rem',
      },
      useDocumentRowTypeColumn({
        cellTemplate: 'documentRowTypeCellTemplate',
      }),
      useSupplierBrandColumn({
        dataField: 'supplier_brand_ref_code',
        lookup: useLookup({ store: registryStore.supplierBrands, valueExpr: 'code' }),
        calculateDisplayValue: supplierBrandDisplayValue,
        width: '5rem'
      }),
      ...useProductColumns(),
      { dataField: 'description', caption: t('common.description') },
      useNotesColumn({ visible: false }),
      useQuantityColumn(),
      { dataField: 'keep_price_discount', dataType: 'boolean', caption: t('common.keepPriceDiscount', 2) },
      useVatTypeColumn(),
      useTotalNoVatColumn(),
      useTotalVatColumn(),
    ]
  }

  return { canEditQuantity, useColumns }
}
